module.exports = (RESTService) ->
  'ngInject'
  {
    service: ->
      RESTService.service('admin/time_zones')
  }
